let url = window.location.protocol+"//"+window.location.host + '/list.json'
export const DEFAULT_TOKEN_LIST_URL = url

export const DEFAULT_LIST_OF_LISTS: string[] = [
  DEFAULT_TOKEN_LIST_URL,
]